import { api } from './api';
import { entriesAddMany } from '../containers/contentSlice';
import { AnchorEntry } from '../types';

export const anchorsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		anchorCreate: builder.mutation<AnchorEntry, AnchorEntry>({
			query: (entry) => {
				const anchor = entry as AnchorEntry;
				return {
					url: 'anchors',
					method: 'POST',
					body: {
						id: anchor.id,
						parentId: anchor.parentId,
						repositoryId: anchor.repositoryId ?? null,
						referenceId: anchor.referenceId ?? null,
						direction: anchor.direction ?? null,
						xy: anchor.xy,
					},
				};
			},
			async onQueryStarted(entry, { dispatch }) {
				dispatch(entriesAddMany([entry]));
			},
		}),
	}),
});

export const { useAnchorCreateMutation } = anchorsApi;
